import { Timestamp } from "@bufbuild/protobuf";
import {
  type CreateDistributionCampaignRequest,
  CreateDistributionCampaignResponse,
  type CreateStandaloneDistributionCodeRequest,
  CreateStandaloneDistributionCodeResponse,
  type GetDistributionCampaignsRequest,
  GetDistributionCampaignsResponse,
  type GetDistributionCodesRequest,
  GetDistributionCodesResponse,
  type GetStandaloneDistributionCodeRequest,
  GetStandaloneDistributionCodeResponse,
} from "schema/gen/es/chiikipoint/adminconsole/v2/service_pb";
import {
  DistributionCampaign,
  FundSource,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";

import { nextPrefixedId, simulateDelay } from "./utils";

export const mockGetDistributionCampaigns = async (
  req: GetDistributionCampaignsRequest,
): Promise<GetDistributionCampaignsResponse> => {
  await simulateDelay();
  const campaigns: DistributionCampaign[] = [
    new DistributionCampaign({
      id: "distribution-campaign-001",
      title: "春の新生活応援キャンペーン",
      fundSource: new FundSource({
        id: "fund_001",
        name: "市民生活支援基金",
      }),
      distributionCount: BigInt(1000),
      consumedCount: BigInt(450),
      distributionBalanceAmount: BigInt(5000),
      balanceExpiresAt: Timestamp.fromDate(new Date("2025-03-31")),
      createdAt: Timestamp.fromDate(new Date("2024-03-01")),
    }),
    new DistributionCampaign({
      id: "distribution-campaign-002",
      title: "地域振興ポイント配布",
      fundSource: new FundSource({
        id: "fund_002",
        name: "地域振興基金",
      }),
      distributionCount: BigInt(500),
      consumedCount: BigInt(120),
      distributionBalanceAmount: BigInt(3000),
      balanceExpiresAt: Timestamp.fromDate(new Date("2025-06-30")),
      createdAt: Timestamp.fromDate(new Date("2024-04-01")),
    }),
  ];

  const filteredCampaigns = req.query?.fundSourceId
    ? campaigns.filter(
        (campaign) => campaign.fundSource?.id === req.query?.fundSourceId,
      )
    : campaigns;

  return new GetDistributionCampaignsResponse({
    distributionCampaigns: filteredCampaigns,
  });
};

export const mockCreateDistributionCampaign = async (
  _req: CreateDistributionCampaignRequest,
): Promise<CreateDistributionCampaignResponse> => {
  await simulateDelay();
  return new CreateDistributionCampaignResponse({
    distributionCampaignId: nextPrefixedId(
      "create-distribution-campaign",
      "distribution-campaign-",
      { pad: 3 },
    ),
  });
};

export const mockGetDistributionCodes = async (
  req: GetDistributionCodesRequest,
): Promise<GetDistributionCodesResponse> => {
  await simulateDelay();
  const prefix =
    req.query?.search.case === "codeSearch"
      ? req.query.search.value.codePrefix.toLowerCase()
      : "00000000";
  const usedAt = Timestamp.fromDate(new Date("2025-01-02T03:04:05+09:00"));
  const count = 10;

  return new GetDistributionCodesResponse({
    codeUsages: Array.from({ length: count }, (_, index) => ({
      distributionCode: {
        code: `${prefix}-0000-4000-8000-${String(index + 1).padStart(12, "0")}`,
        distributionCampaignId:
          index % 2 === 0
            ? "distribution-campaign-001"
            : "distribution-campaign-002",
        userId: index % 2 === 0 ? `user-${index + 1}` : undefined,
        updatedAt: index % 2 === 0 ? usedAt : undefined,
      },
      consumer:
        index % 2 === 0
          ? { subscriptionId: `subscription-${index + 1}` }
          : undefined,
    })),
  });
};

export const mockGetStandaloneDistributionCode = async (
  req: GetStandaloneDistributionCodeRequest,
): Promise<GetStandaloneDistributionCodeResponse> => {
  await simulateDelay();
  return new GetStandaloneDistributionCodeResponse({
    standaloneDistributionCode: {
      code: req.code,
      fundSourceId: "fund_003",
      userId: "user-standalone",
      updatedAt: Timestamp.fromDate(new Date("2025-01-02T03:04:05+09:00")),
    },
    consumer: { subscriptionId: "subscription-standalone" },
  });
};

export const mockCreateStandaloneDistributionCode = async (
  _req: CreateStandaloneDistributionCodeRequest,
): Promise<CreateStandaloneDistributionCodeResponse> => {
  await simulateDelay();
  const code = `DIST-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
  return new CreateStandaloneDistributionCodeResponse({
    distributionCode: code,
    distributionUrl: `https://example.com/distributions/${code}`,
  });
};
